import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import reduxThunk from 'redux-thunk';
import reducers from './reducers';
import './assets/styles/index.css';
import { unregister } from './registerServiceWorker';
import App from './components/app';
import persistState from 'redux-localstorage';
import { LOCAL_STORAGE_CONFIG } from './config';
import * as Sentry from '@sentry/browser';


//////////////////////////////////////
// Javascript error tracking
//////////////////////////////////////
const initSentryTracking = () => {
  if(process.env.REACT_APP_SENTRY_DISABLE === "true") return;

  if(process.env.REACT_APP_ENV === "production") {
    Sentry.init({ dsn: process.env.REACT_APP_SENTRY_LINK});
  }
}
initSentryTracking();
//////////////////////////////////////


const composeEnhancers =
  typeof window === 'object' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
    }) : compose;


const enchancer = composeEnhancers(
  applyMiddleware(
    reduxThunk
  ),
  persistState(['form'], LOCAL_STORAGE_CONFIG)
)


export const store = createStore(reducers, enchancer);


render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

unregister();




//Util - check unneccessary re-renders
// if (process.env.NODE_ENV !== 'production') {

//   const {whyDidYouUpdate} = require('why-did-you-update')
//   whyDidYouUpdate(React)

//   const { reactopt } = require('reactopt');
//   reactopt(React);
// }



// WEBPACK FOOTER //
// ./src/index.js